module.exports = __webpack_public_path__ + "media/images/pokerroom/888/step2-pict01-0a2d32f95e1dca42cfbb714427564c39.jpg";